import { render } from "./StageButtonLink.vue?vue&type=template&id=020c2885&scoped=true&ts=true&lang=pug"
import script from "./StageButtonLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./StageButtonLink.vue?vue&type=script&lang=ts&setup=true"

import "./StageButtonLink.vue?vue&type=style&index=0&id=020c2885&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020c2885"]])

export default __exports__